import { render } from "./PassengerDetails.vue?vue&type=template&id=2b38e6c2"
import script from "./PassengerDetails.vue?vue&type=script&lang=js"
export * from "./PassengerDetails.vue?vue&type=script&lang=js"

import "./PassengerDetails.vue?vue&type=style&index=0&id=2b38e6c2&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__